












































































































































// Internacionalización. Para la presentación de mensajes en diferentes idiomas
import i18nMessages from "./i18n/messages";
//TYpe para validación de formularios
import { VForm } from "@/types/formvalidate";
import GlobalMixin from "@/mixins/global";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  components: {
    // Incluimos el layout que utilizará este módulo
  },
  data() {
    return {
      moduleName: "SIGNIN",
      loading: false,
      showError: false,
      timeout: 3000,
      errorMessage: null,
      isFormValid: true,
      isClearPassword: false,
      username: "",
      usernameRules: [
        (v: any) => !!v || this.$t("lblRule4User1"),
        (v: any) => !['XEXX010101000','XAXX010101000','XXX010101XXX'].find((r: string) => r === v.toUpperCase()) || this.$t("lblRule4User2"),
      ],
      password: "",
      passwordRules: [(v: any) => !!v || this.$t("lblRule4Password6")],
      // Agregando items para el breadcrumb
      itemsBc: [
        {
          text: "lblTitle",
          disabled: true,
          href: "/signin",
        },
      ],
    };
  },
  computed: {
    form(): VForm {
      return this.$refs.signin as VForm;
    },
  },
  methods: {
    doSubmit() {
      this.errorMessage = null;
      if (this.validate()) {
        this.loading = true;
        this.$store
          .dispatch("auth/signIn", {
            username: this.username,
          })
          .then((user: { challengeName: string }) => {
            this.$logger.debug(user);
            if (user.challengeName) {
              if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
                return this.$store
                  .dispatch("auth/newPassword", {
                    user,
                    newPassword: "Palace123.",
                  })
                  .then((data: any) => {
                    this.$logger.debug(data);
                  });
              } else if (user.challengeName === "CUSTOM_CHALLENGE") {
                return this.$store
                  .dispatch("auth/sendCustomChallengeAnswer", {
                    user: user,
                    password: this.password,
                  })
                  .then((data: any) => {
                    if (data.signInUserSession == null) {
                      let e = {
                        code: "NotAuthorizedException",
                        name: "NotAuthorizedException",
                        message: "Incorrect username or password.",
                      };
                      this.loading = false;
                      this.$logger.warn(e);
                      this.errorMessage = this.$t("lblInvalidCredentials");
                      this.showError = true;
                      window.setTimeout(() => {
                        this.errorMessage = null;
                      }, this.timeout);
                    } else {
                      this.$logger.debug(data);
                      window.location.replace("/");
                    }
                  });
              }
            }
          })
          .catch((e: any) => {
            this.loading = false;
            this.$logger.warn(e);
            this.errorMessage = this.$t("lblInvalidCredentials");
            this.showError = true;
            window.setTimeout(() => {
              this.errorMessage = null;
            }, this.timeout);
          })
          .finally(() => {});
      }
    },
    validate() {
      return this.form.validate();
    },
    reset() {
      this.form.reset();
      this.form.resetValidation();
      this.errorMessage = null;
    },
  },
});
